import { gql } from '@apollo/client';

export const DELETE_GROUP_OPTION = gql`
  mutation deleteGroupOption($id: ID!) {
    groupOption: deleteGroupOption(id: $id) {
      id
    }
  }
`;
